var _defs, _path, _path2, _g, _path3, _path4, _rect, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUltraAzul(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3602",
    "data-name": "Grupo 3602",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 571.767,
    height: 139.085,
    viewBox: "0 0 571.767 139.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "blue",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "blue",
    stopOpacity: 0.314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "blue"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4638",
    "data-name": "Caminho 4638",
    d: "M1551.9,491.511l34.884-42.714V436.141H1524.3v18.325H1557.7l-35.12,42.714v12.656h64.862V491.511Z",
    transform: "translate(-1015.68 -407.399)",
    fill: "blue"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4639",
    "data-name": "Caminho 4639",
    d: "M1359.378,488.539c-2.637,0-4.087-2.241-4.087-6.46V433.7H1339.6l-1.978,9.229h-1.187c-4.614-5.537-10.942-10.81-23.6-10.81-23.335,0-37.573,17.929-37.573,39.418,0,20.171,14.107,37.441,37.31,37.441,10.415,0,19.116-4.351,24.258-11.6h1.055c1.45,7.383,6.987,11.6,15.161,11.6a26.882,26.882,0,0,0,10.81-2.241V488.011h-1.714A7.942,7.942,0,0,1,1359.378,488.539Zm-44.164,1.318c-10.547,0-18.72-8.174-18.72-19.116,0-11.6,8.174-19.512,18.589-19.512,10.678,0,18.984,8.7,18.984,19.512A18.986,18.986,0,0,1,1315.214,489.857Z",
    transform: "translate(-866.307 -404.956)",
    fill: "blue"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3576",
    "data-name": "Grupo 3576",
    transform: "translate(229.787 27.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4637",
    "data-name": "Caminho 4637",
    d: "M904.092,488.01a7.941,7.941,0,0,1-2.768.528c-2.637,0-4.087-2.241-4.087-6.46V433.694H881.549l-1.978,9.229h-1.187c-4.614-5.537-10.942-10.811-23.6-10.811-23.335,0-37.573,17.93-37.573,39.419,0,20.171,14.107,37.441,37.309,37.441,10.415,0,19.116-4.351,24.258-11.6h1.054c1.451,6.987,6.988,11.206,15.161,11.206a26.892,26.892,0,0,0,10.811-2.241V488.01Zm-46.933,1.846c-10.547,0-18.721-8.174-18.721-19.116,0-11.6,8.174-19.511,18.589-19.511,10.679,0,18.984,8.7,18.984,19.511A18.986,18.986,0,0,1,857.159,489.856Z",
    transform: "translate(-817.213 -432.112)",
    fill: "blue"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4640",
    "data-name": "Caminho 4640",
    d: "M1117.765,495.709c7.77-5.574,12.814-12.781,12.814-24.537a25.636,25.636,0,0,0-11.6-20.7v-1.186h11.338V434.126h-36.123c-23.071,0-40.737,14.238-40.737,35.6,0,21.885,16.348,35.727,39.815,35.727,9.492,0,15.557,4.219,15.557,11.206,0,5.8-5.405,9.756-12.789,9.756v18.852c22.017,0,35.069-9.756,35.069-27.422A24.274,24.274,0,0,0,1117.765,495.709Zm-25.945-8.19a17.309,17.309,0,0,1-17.666-17.534c0-10.811,7.911-17.93,17.535-17.93a17.309,17.309,0,0,1,17.666,17.534C1109.354,480.4,1101.444,487.519,1091.82,487.519Z",
    transform: "translate(-960.644 -433.335)",
    fill: "blue"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4644",
    "data-name": "Caminho 4644",
    d: "M914.2,665.875c26.5,0,30.058-14.238,48.647-14.238s22.148,14.238,48.647,14.238V647.023c-21.489,0-22.939-14.238-48.647-14.238s-27.158,14.238-48.647,14.238Z",
    transform: "translate(-876.094 -553.948)",
    fill: "url(#linear-gradient)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4641",
    "data-name": "Caminho 4641",
    d: "M693.054,507.391h21.357v-35.2c0-14.634,9.756-19.38,19.775-19.38h2.636v-20.7h-2.5c-9.229,0-16.743,4.087-20.961,10.019H712.3L710.06,433.7H693.054Z",
    transform: "translate(-512.045 -404.956)",
    fill: "blue"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4642",
    "data-name": "Caminho 4642",
    d: "M566.473,486.155c4.614,0,11.338-.791,15.425-2.769V464.534h-1.45a22.927,22.927,0,0,1-9.887,2.373c-8.306,0-12.92-4.219-12.92-14.5v-23.73h21.884v-17.8H557.508V394.53H541.424l-3.3,16.347H525.6v17.8h10.678v23.467C536.282,476.663,548.148,486.155,566.473,486.155Z",
    transform: "translate(-409.783 -382.138)",
    fill: "blue"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2186",
    "data-name": "Ret\\xE2ngulo 2186",
    width: 21.357,
    height: 102.435,
    transform: "translate(85.418)",
    fill: "blue"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4643",
    "data-name": "Caminho 4643",
    d: "M268.043,511.417c21.225,0,36.123-12.392,36.123-34.936V436.14H282.808v39.946c0,10.151-5.273,16.215-14.633,16.215s-14.5-6.2-14.5-16.611V436.14H232.316v40.341C232.316,498.761,246.422,511.417,268.043,511.417Z",
    transform: "translate(-232.316 -407.399)",
    fill: "blue"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltraAzul);
export default __webpack_public_path__ + "static/media/ultra-azul.8b164bcf5aa049ec716ba43f30444deb.svg";
export { ForwardRef as ReactComponent };